import { useEffect } from "react";

function useEscapeKey(handler) {
  useEffect(() => {
    // Định nghĩa hàm xử lý sự kiện
    const handleEscape = (event) => {
      if (event.key === "Escape") {
        handler(); // Gọi hàm handler khi nhấn phím Escape
      }
    };

    // Thêm sự kiện 'keydown' khi component mount
    document.addEventListener("keydown", handleEscape);

    // Xóa sự kiện 'keydown' khi component unmount
    return () => {
      document.removeEventListener("keydown", handleEscape);
    };
  }, [handler]); // handler là dependency để đảm bảo hook luôn sử dụng hàm mới nhất
}

export default useEscapeKey;